
export default {
    SET_NOTIFICATIONS: function (state, notifications) {
        notifications.map(element => {
            element.begin = '2022-10-01';
            element.end = '2023-03-01';
            element.description = 'Blueberry Season 2022/2023';
        });
        state.notifications = notifications;
    },
    SET_NOTIFICATIONS_LOADING: function (state, status) {
        state.notificationsLoading = status;
    },
    SET_VIEW_NOTIFICATIONS_MANAGER: function (state, status) {
        state.viewNotificationsManager = status;
    },
    SET_NOTIFICATIONS_CREATING: function (state, status) {
        state.notificationCreating = status;
    },
}
